import {RequestAnfrage} from "../../model/request.anfrage";
import {Input} from "../interfaces/input";

/**
 * Class holds all the data of the request inside the thermostatcheck that the user needs for the frontend.
 */
export class WarmwassercheckAnfrage implements RequestAnfrage{
  /**
   * holds the last update we did on the local data
   */
  lastupdate: number;

  /**
   * holds the currecnty active portalId for this request
   */
  portalId: string;

  /**
   * Input of the user
   */
  userInput: Input = {};

  /**
   * result of the user's dialog registration
   */
  dialogResult: string;

  /**
   * Holds the result from the calculation
   */
  result: any = {};

  /**
   * @inheritdoc
   */
  campaignId: string = null;

  /**
   * @inheritdoc
   */
  lastPath: string = null;
}
